import { Component, signal, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { AppButton, AppButtonColor } from '../../../../features/client/components/atom/app-button/app-button';
import { NewsletterApiService } from '../../../../core/api/newsletter-api.service';
import { FormErrorDisplayComponent } from '../../../../shared/components/form-validation-errors/form-error-display/form-error-display';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-newsletter',
  imports: [
    ReactiveFormsModule,
    FormErrorDisplayComponent,
    AppButton,
    InputText,
    TranslatePipe
  ],
  templateUrl: './app-newsletter.html'
})
export class AppNewsletter {
  newsletterEmail = new FormControl('', {validators: [Validators.email], nonNullable: true});
  subscribingToNewsletter = signal(false);
  subscribed = signal(false);
  @Input() buttonColor: AppButtonColor = 'primary';

  constructor(private newsletterApiService: NewsletterApiService) {}

  subscribeToNewsletter(): void {
    if (!this.newsletterEmail.value || this.newsletterEmail.invalid || this.subscribingToNewsletter()) {
      return;
    }

    this.subscribingToNewsletter.set(true);
    this.newsletterEmail.disable();

    this.newsletterApiService.subscribe(this.newsletterEmail.value).subscribe({
      next: () => {
        this.subscribingToNewsletter.set(false);
        this.subscribed.set(true);
        this.newsletterEmail.reset();
        this.newsletterEmail.enable();
      },
      error: () => {
        this.subscribingToNewsletter.set(false);
        this.newsletterEmail.enable();
      },
    });
  }
}
